<coin-v2-dialog-frame [header]="'cms.news.add-content' | translate">
  <div class="body-container">
    <h3>Please select</h3>
    <div class="inner-content">
      <div class="content-column">
        @for (item of allSelectableItems; track item) {
          <coin-v2-button
            class="list-button"
            [type]="'secondary'"
            [icon]="'add'"
            [text]="item.type | translate"
            (click)="viewThisItem($any(item))"></coin-v2-button>
        }
      </div>
      <div class="item-selection-wrapper">
        @if (viewItem) {
          <div
            class="selected-item-view"
            animate.enter="expand"
            animate.leave="shrink">
            @if (viewItem.type === 'image-slider') {
              <coin-gmm-image-slider [item]="viewItem"></coin-gmm-image-slider>
            }
            @if ($any(viewItem.type) === 'quote') {
              <coin-gmm-quote [item]="viewItem"></coin-gmm-quote>
            }
            @if (viewItem.type === 'picture-container') {
              <coin-gmm-picture-container [item]="viewItem"></coin-gmm-picture-container>
            }
            @if (viewItem.type === 'compilation') {
              <coin-gmm-compilation
                [item]="viewItem"
                [startanimation]="true"></coin-gmm-compilation>
            }
            @if (viewItem.type === 'numbers') {
              <coin-gmm-numbers
                [item]="viewItem"
                [startanimation]="true"></coin-gmm-numbers>
            }
            @if (viewItem.type === 'spacer') {
              <p>Just some space between parts</p>
            }
            @if (viewItem.type === 'spacer') {
              <coin-gmm-spacer
                class="spacer-item"
                [item]="viewItem"></coin-gmm-spacer>
            }
            @if (viewItem.type === 'text-block') {
              <coin-gmm-text-block [item]="viewItem"></coin-gmm-text-block>
            }
            @if (viewItem.type === 'text-image-link') {
              <coin-gmm-text-image-link [item]="viewItem"></coin-gmm-text-image-link>
            }
            @if (viewItem.type === 'editor' || viewItem.type === 'bullet-list' || viewItem.type === 'email-headline') {
              <coin-html-editor [item]="viewItem"></coin-html-editor>
            }
            @if (viewItem.type === 'headline-with-subheadline') {
              <coin-news-headline [item]="viewItem"></coin-news-headline>
            }
            @if (viewItem.type === 'expand-box') {
              <coin-equity-expand-box [item]="viewItem"></coin-equity-expand-box>
            }
            @if (viewItem.type === 'expand-linksbox') {
              <coin-equity-expand-linksbox [item]="viewItem"></coin-equity-expand-linksbox>
            }
            @if (viewItem.type === 'button') {
              <coin-cms-button [item]="viewItem"></coin-cms-button>
            }
            @if (viewItem.type === 'download-file') {
              <coin-download-file [item]="viewItem"></coin-download-file>
            }
            @if (viewItem.type === 'email-button') {
              <coin-email-button [item]="viewItem"></coin-email-button>
            }
            @if (viewItem.type === 'email-quote') {
              <coin-a-email-quote [item]="$any(viewItem)"></coin-a-email-quote>
            }
            @if (viewItem.type === 'chapter') {
              <coin-equity-cms-chapter [item]="viewItem"></coin-equity-cms-chapter>
            }
            @if (viewItem.type === 'chapter-overview') {
              <coin-equity-cms-chapter-overview [item]="$any(viewItem.content)"></coin-equity-cms-chapter-overview>
            }
            @if (viewItem.type === 'cards') {
              <coin-equity-cms-cards [item]="viewItem"></coin-equity-cms-cards>
            }
            @if (viewItem.type === 'single-or-multi-image') {
              <coin-email-single-double-image [item]="viewItem"></coin-email-single-double-image>
            }
            @if (viewItem.type === 'video') {
              <coin-email-video [item]="viewItem"></coin-email-video>
            }
            @if (viewItem.type === 'full-width-part-with-image') {
              <coin-equity-cms-full-widthpart-with-image [item]="viewItem"></coin-equity-cms-full-widthpart-with-image>
            }
            @if (viewItem.type === 'main-body-image-text') {
              <coin-email-main-body-image-text [item]="viewItem"></coin-email-main-body-image-text>
            }
            @if (viewItem.type === 'email-footnotes') {
              <coin-a-email-footnotes [item]="$any(viewItem)"></coin-a-email-footnotes>
            }
            @if (viewItem.type === 'index-list') {
              <div>
                <p>
                  {{ 'cms.emails.index-list-preview-info-text' | translate }}
                </p>
                <br />
                <ul>
                  <li><h2>Headline</h2></li>
                  <li><h4>Subheadline</h4></li>
                </ul>
                <coin-gmm-line></coin-gmm-line>
                <ul>
                  <li>Bullet List</li>
                </ul>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <coin-v2-dialog-footer color="gradient">
    <coin-v2-button
      [type]="'secondary'"
      [icon]="'close'"
      [iconPos]="'right'"
      [text]="'general.btnClose' | translate"
      (click)="close()"></coin-v2-button>
    @if (viewItem) {
      <coin-v2-button
        [type]="'primary'"
        [icon]="'add'"
        [iconPos]="'right'"
        [text]="'cms.news.add-this-content' | translate"
        (click)="addThisContent()"></coin-v2-button>
    }
  </coin-v2-dialog-footer>
</coin-v2-dialog-frame>
